import React, {useState} from "react";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {Message} from "primereact/message";
import {useWorkspace} from "../../models/workspace/use-workspace";
import {useTranslate} from "../../system/useTranslate";

export function Init({onCreated, closable = false, onClose}) {
    const translate = useTranslate();
    const workspaceApi = useWorkspace();
    const [name, setName] = useState("");
    const [slug, setSlug] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const submit = async (event) => {
        event.preventDefault();
        if (name.trim().length < 2 || loading) return;
        setLoading(true);
        setError("");
        try {
            const result = await workspaceApi.createWorkspace({workspace: {
                name: name.trim(),
                ...(slug.trim() ? {slug: slug.trim().toLowerCase()} : {}),
            }});
            onCreated?.(result);
        } catch (requestError) {
            setError(requestError?.message || "workspace-onboarding.error.submit");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="w-full h-full flex align-items-center justify-content-center p-3 surface-ground">
            <form className="surface-card border-round-2xl shadow-2 p-4 md:p-5 w-full md:w-30rem flex flex-column gap-4" onSubmit={submit}>
                <div><h1 className="text-2xl m-0">{translate("create-new-workspace")}</h1><p className="text-xs text-500 line-height-3">{translate("workspace-create-description")}</p></div>
                {error && <Message severity="error" text={translate(error)} className="text-xs"/>}
                <label className="flex flex-column gap-2"><span className="text-xs font-semibold">{translate("workspace-name")}</span><InputText value={name} onChange={(event) => setName(event.target.value)} autoFocus maxLength={120}/></label>
                <label className="flex flex-column gap-2"><span className="text-xs font-semibold">{translate("workspace-slug")}</span><InputText value={slug} onChange={(event) => setSlug(event.target.value.replace(/[^a-zA-Z0-9-]/g, ""))} maxLength={80}/></label>
                <div className="flex justify-content-end gap-2">{closable && <Button type="button" text severity="secondary" label={translate("cancel")} onClick={onClose}/>}<Button type="submit" loading={loading} disabled={name.trim().length < 2} label={translate("create")}/></div>
            </form>
        </div>
    );
}

export default Init;
